import { createDispute } from '../../api/disputes';

export const disputes = {
  effects: {
    async createDispute(createDisputRequest) {
      return createDispute(createDisputRequest);
    }
  },
  reducers: null,
  state: null
};
